import MediaLibraryCollectionStorage from './storage-collection';
import MediaLibraryClient from '../clients/MediaLibraryClient';
import MediaLibraryEvents from './events';

class MediaLibraryCollectionValidator
{
    constructor()
    {
        // Imports
        this.mediaLibraryCollectionStorage = new MediaLibraryCollectionStorage();
        this.mediaLibraryClient = new MediaLibraryClient();

        // Events
        this.validateCollectionEvent = new Event(MediaLibraryEvents.validateCollection);

        // Helpers
        this.customerId = orion.getCustomerId();
        this.storedCollection = this.getCollection();
        this.storedTimestamp = this.getTimestamp();
        this.currentTimestamp = Date.now();
        this.validationInterval = 2592000;  // 30 minutes in milliseconds: 30 * 60 * 1000
    }

    init()
    {
        if (this.storedCollection && this.storedTimestamp)
        {
            if (this.validateTimestamp()) this.validateCollection();
        }
        else if (this.storedCollection && !this.storedTimestamp)
        {
            this.validateCollection();
        }
    }

    validateCollection()
    {
        const MAX_SIZE = 1000; // Maximum number of assets that can be requested

        this.mediaLibraryClient.fetchAssetsByAssetIds(
            this.storedCollection,
            MAX_SIZE,
            0
        ).then(response => response.json())
            .then(assets =>
            {
                let receivedAssets = assets.items.map(asset => asset.attributes.assetId);

                let unknownAssetIds = this.storedCollection.filter(assetId => !receivedAssets.includes(assetId));

                if (unknownAssetIds.length)
                {
                    this.removeFromCollection(unknownAssetIds);

                    this.dispatchEvent(this.validateCollectionEvent);
                }

                if (receivedAssets.length)
                {
                    this.setTimestamp();
                }
                else
                {
                    this.clearCollection();
                    this.removeTimestamp();
                }
            });
    }

    /**
     * @return {Boolean} Whether the timestamp exceeds the interval
     */
    validateTimestamp()
    {
        return (this.currentTimestamp - parseInt(this.storedTimestamp)) > this.validationInterval;
    }

    setTimestamp()
    {
        this.mediaLibraryCollectionStorage.setTimestamp(this.customerId);
    }

    removeTimestamp()
    {
        this.mediaLibraryCollectionStorage.removeTimestamp(this.customerId);
    }

    /**
     * @param {Event} event - The event to dispatch
     */
    dispatchEvent(event)
    {
        document.dispatchEvent(event);
    }

    /**
     * @param {Number[]} unknownAssetIds - The Asset IDs to remove
     */
    removeFromCollection(unknownAssetIds)
    {
        unknownAssetIds.forEach((assetId) =>
        {
            this.mediaLibraryCollectionStorage.removeFromCollection(assetId);
        });

        this.mediaLibraryCollectionStorage.saveCollection(this.customerId);
    }

    clearCollection()
    {
        this.mediaLibraryCollectionStorage.clearCollection(this.customerId);
    }

    /**
     * @return {Array} Asset IDs in collection
     */
    getCollection()
    {
        if (this.mediaLibraryCollectionStorage.hasCollection(this.customerId))
        {
            this.mediaLibraryCollectionStorage.restoreCollection(this.customerId);
            return this.mediaLibraryCollectionStorage.getCollection();
        }
    }

    /**
     * @return {Number} Collection timestamp
     */
    getTimestamp()
    {
        if (this.mediaLibraryCollectionStorage.hasTimestamp(this.customerId))
        {
            return this.mediaLibraryCollectionStorage.getTimestamp(this.customerId);
        }
    }
}

if (document.querySelector('body').classList.contains('authorized'))
{
    let mediaLibraryCollectionValidator = new MediaLibraryCollectionValidator();

    mediaLibraryCollectionValidator.init();
}
